const quickAddBtn = document.querySelector('.quick-add.no-js-hidden button');
const targetElement = document.querySelector('.fr-collection-quick-add.no-js-hidden');

quickAddBtn.addEventListener('mouseenter', () => {
  targetElement.style.left = '60%';
});

quickAddBtn.addEventListener('mouseleave', () => {
  targetElement.style.left = 'original_value'; // replace this with your original left value, if needed
});
